import { ResetPassword } from "./ResetPassword";

export {
    ResetPassword,
    ResetPasswordWithoutCommercePlatform,
    validateEmail,
} from "./ResetPassword";

export default ResetPassword;
